/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Devine, Robinson, Miller and Hamwi formulas differ slightly. Seeing the range is more informative than trusting one exact figure.`)
};

const es_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fórmulas de Devine, Robinson, Miller y Hamwi difieren ligeramente. Ver el rango es más informativo que confiar en una única cifra exacta.`)
};

const de_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Formeln von Devine, Robinson, Miller und Hamwi unterscheiden sich leicht. Die Spanne zu sehen ist aussagekräftiger, als sich auf einen einzelnen exakten Wert zu verlassen.`)
};

const nl_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De formules van Devine, Robinson, Miller en Hamwi verschillen licht. De bandbreedte zien is informatiever dan op één exact getal te vertrouwen.`)
};

const fr_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les formules de Devine, Robinson, Miller et Hamwi diffèrent légèrement. Voir la fourchette est plus informatif que de se fier à un chiffre exact unique.`)
};

const it_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le formule di Devine, Robinson, Miller e Hamwi differiscono leggermente. Vedere l'intervallo è più informativo che fidarsi di un unico valore esatto.`)
};

const pt_br2_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fórmulas de Devine, Robinson, Miller e Hamwi variam um pouco. Ver a faixa é mais informativo do que confiar em um único valor exato.`)
};

const pt_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fórmulas de Devine, Robinson, Miller e Hamwi diferem ligeiramente. Ver o intervalo é mais informativo do que confiar num único valor exato.`)
};

const ja_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイン式、ロビンソン式、ミラー式、ハムウィ式はそれぞれわずかに異なります。範囲を見るほうが、1つの正確な数値を信頼するより参考になります。`)
};

const zh_iw_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devine、Robinson、Miller 和 Hamwi 公式的结果略有差异。看到一个范围比只相信某一个精确数值更有参考价值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_a2", locale)
	if (locale === "en") return en_iw_faq_a2(inputs)
	if (locale === "es") return es_iw_faq_a2(inputs)
	if (locale === "de") return de_iw_faq_a2(inputs)
	if (locale === "nl") return nl_iw_faq_a2(inputs)
	if (locale === "fr") return fr_iw_faq_a2(inputs)
	if (locale === "it") return it_iw_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_a2(inputs)
	if (locale === "pt") return pt_iw_faq_a2(inputs)
	if (locale === "ja") return ja_iw_faq_a2(inputs)
	return zh_iw_faq_a2(inputs)
};